export const START_INITIALIZATION = 'EVENT/START_INITIALIZATION';
export const COMPLETE_INITIALIZATION = 'EVENT/COMPLETE_INITIALIZATION';
